<template>
  <a-modal
    :visible="true"
    :title="`${$t('synchronization.parse_errors')} (${errors.length})`"
    :footer="null"
    :width="960"
    :z-index="10000"
    @cancel="$emit('close')"
  >
    <div
      ref="viewport"
      class="parse-errors"
      tabindex="0"
      role="region"
      :aria-label="$t('synchronization.parse_errors')"
      @scroll.passive="onScroll"
    >
      <div
        class="parse-errors__space"
        :style="{ height: `${errors.length * rowHeight}px` }"
      >
        <div
          class="parse-errors__rows"
          role="list"
          :style="{ top: `${startIndex * rowHeight}px` }"
        >
          <div
            v-for="(error, index) in visibleErrors"
            :key="startIndex + index"
            class="parse-errors__row"
            role="listitem"
            :aria-posinset="startIndex + index + 1"
            :aria-setsize="errors.length"
            :style="{ height: `${rowHeight}px` }"
          >
            <span class="parse-errors__number">{{ startIndex + index + 1 }}.</span>
            {{ error }}
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
// 400,000 rows occupy 12.8M px, within browser scroll-height limits.
const ROW_HEIGHT = 32
const VIEWPORT_HEIGHT = 480
const OVERSCAN = 8

export default {
  props: {
    errors: { type: Array, required: true }
  },
  data() {
    return { scrollTop: 0, rowHeight: ROW_HEIGHT }
  },
  computed: {
    startIndex() {
      const lastStart = Math.max(0, this.errors.length - Math.ceil(VIEWPORT_HEIGHT / ROW_HEIGHT))
      return Math.max(0, Math.min(lastStart, Math.floor(this.scrollTop / ROW_HEIGHT)) - OVERSCAN)
    },
    visibleErrors() {
      return this.errors.slice(
        this.startIndex,
        this.startIndex + Math.ceil(VIEWPORT_HEIGHT / ROW_HEIGHT) + OVERSCAN * 2
      )
    }
  },
  watch: {
    errors() {
      this.scrollTop = 0

      if (this.$refs.viewport) this.$refs.viewport.scrollTop = 0
    }
  },
  methods: {
    onScroll(event) {
      this.scrollTop = event.target.scrollTop
    }
  }
}
</script>

<style scoped lang="scss">
.parse-errors {
  height: 480px;
  max-height: 60vh;
  overflow: auto;
  border: 1px solid #e8e8e8;

  &__space {
    position: relative;
  }

  &__rows {
    position: absolute;
    width: max-content;
    min-width: 100%;
  }

  &__row {
    box-sizing: border-box;
    padding: 0 12px;
    line-height: 31px;
    border-bottom: 1px solid #f0f0f0;
    white-space: nowrap;

    &:nth-child(even) {
      background: #fafafa;
    }
  }

  &__number {
    display: inline-block;
    min-width: 64px;
    color: #8c8c8c;
  }
}
</style>
